const { NEXT_PUBLIC_DEV_CF_ACCESS_CLIENT_ID } = process.env
const { NEXT_PUBLIC_DEV_CF_ACCESS_CLIENT_SECRET } = process.env

// provides headers needed to access masterclass.dev from local dev
export const getDevAccessHeaders = () =>
  typeof NEXT_PUBLIC_DEV_CF_ACCESS_CLIENT_ID === 'string' && {
    'CF-Access-Client-Id': NEXT_PUBLIC_DEV_CF_ACCESS_CLIENT_ID,
    'CF-Access-Client-Secret': NEXT_PUBLIC_DEV_CF_ACCESS_CLIENT_SECRET,
  }
